<!-- container-xxl -->
<!-- <div class="content-wrapper p-0" > -->
<!-- <app-content-header [contentHeader]="contentHeader"></app-content-header> -->
<!-- <div class="row"> -->
<!-- <div class="slider-outer-container"> -->
<!-- <div class="content-body"> -->
<!-- app e-commerce details start -->
<!-- <section class="app-ecommerce-details"> -->
<!-- <div class="card"> -->
<!-- Related Products starts -->
<!-- <div class="card-body"> -->
<!-- <div  class="swiper-container" [swiper]="swiperResponsive">
								<div class="swiper-wrapper">
									<div class="swiper-slide" *ngFor="let relatedProduct of relatedProducts">
										<div class="img-container"> -->
<!-- <img [src]="relatedProduct.image" class="img-fluid swiper-lazy" alt="image" /> -->
<!-- <img src="assets/images/main-home-slider/Group 71.png" alt="Group-banner" style="width: 100%;">
										</div>
									</div>
								</div>
							 
								<div class="swiper-scrollbar"></div>
								<div class="swiper-pagination"></div>
							 
								<div class="swiper-button-prev"></div>
								<div class="swiper-button-next"></div>
							</div>
							<div class="announcement latest-announcement" style="display: flex;">
								- <img src="/assets/images/logo/announce.png" class="announce" alt="" style="width: 200px;"> -->
<!-- <span class="span-latest-announce">LATEST ANNOUNCEMENT</span>
								<marquee style="margin: 7px;padding: .7rem;" behavior="scroll" direction="left" scrollamount="6" scrolldelay="120" onmouseover="this.stop();" onmouseout="this.start();"> -->
<!-- <a href="{{documentURL}}/Corrigendum_for_RERTD_Extension.pdf" target="_blank" title="Click here Download">
										<span style="font-weight:bold; color:black; font-size:12px;">1). “EXTENSION OF LAST DATE TILL 15TH AUGUST, 2022 FOR “CALL FOR PROPOSALS” UNDER RENEWABLE ENERGY RESEARCH & TECHNOLOGY DEVELOPMENT PROGRAMME (RE-RTD-2022).” <i class="fa fa-file-pdf-o" style="color:rgba(199, 13, 13, 0.849)" aria-hidden="true"></i></span>
									</a> -->
<!-- <a href="{{documentURL}}/Call_for_Proposal_for_uploading_on_website.pdf" target="_blank" title="Click here Download">
										<span style="font-weight:bold; color:white; font-size:12px;">1). CALL FOR PROPOSALS FOR RENEWABLE ENERGY RESEARCH AND TECHNOLOGY DEVELOPMENT PROGRAMME (RE-RTD-2022) <i class="fa fa-file-pdf-o" style="color:rgba(199, 13, 13, 0.849)" aria-hidden="true"></i></span>
									</a>
								</marquee>
							</div>
							<div class="news-main-container"> -->
<!-- <div class="news-inner-container">
									<h3>Overview of R&D Portal</h3>
									<p>. Overview of R&D Portal Overview of R&D Portal Overview of R&D Portal Overview of R&D Portal Overview of R&D Portal</p>
									<p>. Overview of R&D Portal Overview of R&D Portal Overview of R&D Portal Overview of R&D Portal Overview of R&D Portal</p>
									<p>. Overview of R&D Portal Overview of R&D Portal Overview of R&D Portal Overview of R&D Portal Overview of R&D Portal</p>
									<p>. Overview of R&D Portal Overview of R&D Portal Overview of R&D Portal Overview of R&D Portal Overview of R&D Portal</p>
								</div>
								<div class="news-inner-container">
								<div class="news_header">
									<div class="newshead" >
										<a href="{{documentURL}}/Call_for_Proposal_for_uploading_on_website.pdf" target="_blank" title="Click here Download"><h1><span>MNRE R&D in News</span>
										</h1></a> -->
<!-- &nbsp; <i class="fa fa-file-pdf-o" style="font-size: 18px!important; color:#fff;" aria-hidden="true"></i> -->
<!-- </div> -->
<!-- <div class="col-3 allnews">
											<a href="javascript:void(0)"><span style="color: white;">View All</span></a>
									</div> -->
<!-- </div>
							<div class="news_content">
								<marquee behavior="scroll" direction="up" scrollamount="6" scrolldelay="120" onmouseover="this.stop();"
								 onmouseout="this.start();" style="min-height:370px;">
									<table class="table">
										<tr>
											<td>
												<h5 style="color:green; font-size:1.3em">May</h5>
												<h3>26</h3>
											</td>
											<td>
												<a href="{{documentURL}}/documentUploads/ImportantDocs/Guidelines_1_How_to_Submit_Research_Proposal.pdf" target="_blank" title="Click here Download"><p style="font-weight:bold; color:black; font-size:12px;">Guidelines how to Submit Research Proposal.</p></a>
											</td>
										</tr>
										<tr>
											<td>
												<h5 style="color:green; font-size:1.3em">May</h5>
												<h3>26</h3>
											</td>
											<td>
												<a href="{{documentURL}}/documentUploads/ImportantDocs/Guidelines_1_How_to_Submit_Research_Proposal.pdf" target="_blank" title="Click here Download"><p style="font-weight:bold; color:black; font-size:12px;">Guidelines how to Submit Research Proposal.</p></a>
											</td>
										</tr> -->
<!-- </table> -->

<!-- </marquee>
							</div> -->
<!-- </div> -->
<!-- </div>
						</div> -->
<!-- </div> -->
<!-- </section>
			</div>
		</div>
		
	</div> -->
<!-- <div class="row">
		<div class="col-12">
			<div class="content-body"> -->
<!-- app e-commerce details start -->
<!-- <section class="app-ecommerce-details">
					<div class="card"> -->
<!-- Related Products starts -->
<!-- <div class="card-body">
							<div class="announcement" style="display: flex;">
							<img src="/assets/images/logo/announce.png" class="announce" alt="" style="width: 200px;">
							<marquee style="margin: 7px;" behavior="scroll" direction="left" scrollamount="6" scrolldelay="120" onmouseover="this.stop();" onmouseout="this.start();"> -->
<!-- <a href="{{documentURL}}/Corrigendum_for_RERTD_Extension.pdf" target="_blank" title="Click here Download">
									<span style="font-weight:bold; color:black; font-size:12px;">1). “EXTENSION OF LAST DATE TILL 15TH AUGUST, 2022 FOR “CALL FOR PROPOSALS” UNDER RENEWABLE ENERGY RESEARCH & TECHNOLOGY DEVELOPMENT PROGRAMME (RE-RTD-2022).” <i class="fa fa-file-pdf-o" style="color:rgba(199, 13, 13, 0.849)" aria-hidden="true"></i></span>
								</a> -->
<!-- <a href="{{documentURL}}/Call_for_Proposal_for_uploading_on_website.pdf" target="_blank" title="Click here Download">
									<span style="font-weight:bold; color:black; font-size:12px;">1). CALL FOR PROPOSALS FOR RENEWABLE ENERGY RESEARCH AND TECHNOLOGY DEVELOPMENT PROGRAMME (RE-RTD-2022) <i class="fa fa-file-pdf-o" style="color:rgba(199, 13, 13, 0.849)" aria-hidden="true"></i></span>
								</a>
							</marquee>
						</div>
					</div>
					</div>
				</section>
			</div> -->
<!-- </div>
	</div> -->
<!-- <div class="row">
		<div class="col-4"> -->
<!-- app e-commerce details start -->
<!-- <section class="app-ecommerce-details">
			<div class="card" style="overflow: hidden; border-bottom: 5px solid #ff8040;"> -->
<!-- Related Products starts -->
<!-- <div class="card-body">
					<div class="news_header">
						<div class="col-9 newshead">
							<a href="{{documentURL}}/Call_for_Proposal_for_uploading_on_website.pdf" target="_blank" title="Click here Download"><h1><span style="color: white;">Latest News</span> &nbsp; <i class="fa fa-file-pdf-o" style="font-size: 18px!important; color:#fff;" aria-hidden="true"></i></h1></a>
						</div>
						<div class="col-3 allnews">
								<a href="javascript:void(0)"><span style="color: white;">View All</span></a>
						</div>
				</div>
				<div class="news_content">
					<marquee behavior="scroll" direction="up" scrollamount="6" scrolldelay="120" onmouseover="this.stop();"
					 onmouseout="this.start();" style="min-height:370px;">
						<table class="table">
							<tr>
								<td>
									<h5 style="color:green; font-size:1.3em">May</h5>
									<h3>26</h3>
								</td>
								<td>
									<a href="{{documentURL}}/documentUploads/ImportantDocs/Guidelines_1_How_to_Submit_Research_Proposal.pdf" target="_blank" title="Click here Download"><p style="font-weight:bold; color:black; font-size:12px;">Guidelines how to Submit Research Proposal.</p></a>
								</td>
							</tr>
						</table>
						
					</marquee>
				</div>
				</div>
			</div>
		</section>
		</div>
	</div> -->
<!-- <div class="row">
		<div class="col-md-3"  *ngFor="let dashboard of dashboardCount">
			<div class="content-body">
				<section class="app-ecommerce-details">
					<div class="card text-center">
						<div class="card-body border-style" [style.background-color]="dashboard.bgcolor">
							<div class="icon-bg p-50 m-0 mb-1" [style.color]="dashboard.bgcolor">
								<div class="avatar-content">
									<i [data-feather]="dashboard.icon" class="font-medium-5"></i>
								</div>
							</div>
							<div *ngIf="dashboard.totalCost <= 0">
								<h4 class="font-weight-bolder text-white">{{dashboard.title}}</h4>
								<h3 class="mb-0 line-ellipsis text-white">{{dashboard.value}}</h3>
							</div>
							<div *ngIf="dashboard.totalCost > 0">
							<div class="row" >
								<div class="col-12">
									<h4 class="font-weight-bolder text-white">{{dashboard.title}}</h4>
								</div> -->
<!-- <div class="col-6">
									<h4 class="font-weight-bolder text-white">Total Cost</h4>
								</div> -->
<!-- </div>
							<div class="row" *ngIf="dashboard.totalCost > 0">
								<div class="col-12">
									<h3 class="mb-0 line-ellipsis text-white">{{dashboard.value}}</h3>
								</div> -->
<!-- <div class="col-6">
									<h3 class="mb-0 line-ellipsis text-white">{{dashboard.totalCost}}</h3>
								</div> -->
<!-- </div>
						</div>
						</div>
					</div>
				</section>
			</div>
		</div>
	</div>
</div> -->

<!-- <div class="sign-in-container">
	<a class="button" type="button" href="/login"><span>Sign in</span></a>
</div> -->
<!-- container-xxl -->
 <style>
	.external-event {
		padding: 10px 15px;
    font-weight: bold;
    margin-bottom: 4px;
    box-shadow: 0 1px 1px rgba(0, 0, 0, 0.1);
    text-shadow: 0 1px 1px rgba(0, 0, 0, 0.1);
    border-radius: 3px;
    cursor: move;
    background-color: #f39c12 !important;
    color: white;
}
.external-event:hover {background-color: #c27c0d !important; text-decoration: underline;
    color: white;}
	.blinking{
		
		height: 50px;
	    
		padding: 15px;	
		text-align: center;
		line-height: 50px;
	}
	.blinking span{
		font-size: 25px;
		font-family: cursive;
		color: white;
		animation: blink 1s linear infinite;
	}
@keyframes blink{
0%{opacity: 0;}
50%{opacity: .5;}
100%{opacity: 1;}
}
 </style>
<div class="content-wrapper home-content-wrapper p-0 content-aboutus-outer-container">
	<div class="content-body">
		<section class="app-ecommerce-details section-container">
			<div class="swiper-container slider-outer-container" [swiper]="swiperResponsive">
				<div class="swiper-wrapper slider-inner-container">
					<div class="swiper-slide slider-inner-box-container" *ngFor="let item of relatedProducts">
						<div class="img-container slider-img-container">
							<!-- <img src="assets/images/main-home-slider/Group_82.jpg" alt="Group-banner" > -->
							<img src="{{item.src}}" alt="Group-banner">
						</div>
					</div>
				</div>

				<!-- <div class="swiper-scrollbar"></div> -->
				<div class="swiper-pagination"></div>
				<div class="swiper-button-prev"></div>
				<div class="swiper-button-next"></div>
			</div>

			<div class="announcement latest-announcement" style="display: flex;">
				<span class="span-latest-announce">
					<img src="assets/images/main-home-slider/Group 135.png" alt="">
				</span>
				<marquee style="line-height: 3rem;" behavior="scroll" direction="left" scrollamount="6"
					scrolldelay="120" onmouseover="this.stop();" onmouseout="this.start();">

					<a href="{{documentURL}}/Call-for-Proposals-document-Innovation-Challenge-for-Circularity-in-Renewable-Energy-Technologies.pdf" target="_blank"
						title="Click here Download">
						<span class="span-first" style="font-size: 13px;font-weight: 500; color: #fff;">
								<span style="font-size: 13px;font-weight: 500; color: #fff;">
									The online application process for the Innovation Challenge on Circularity in Renewable Energy Technologies will commence on 23/06/2025. – <i class="fa fa-file-pdf-o" style="color:rgba(199, 13, 13, 0.849)"
										aria-hidden="true"></i></span>
						
							</span>
					</a>&nbsp;

					<a href="{{documentURL}}/Final_Extension_for_R&D_Call_for_Proposals.pdf" target="_blank"
						title="Click here Download">
						<span class="span-first" style="font-size: 13px;font-weight: 500; color: #fff;">
								<span style="font-size: 13px;font-weight: 500; color: #fff;">
									Final Extension for submission of proposals under R&D Scheme for Green
Hydrogen [The last date of submission of applications is 12.05.2024] – <i class="fa fa-file-pdf-o" style="color:rgba(199, 13, 13, 0.849)"
										aria-hidden="true"></i></span>
						
							</span>
					</a>&nbsp;

					<a href="{{documentURL}}/Extension_of_R&D_Proposals_Submission_Deadline.pdf" target="_blank"
						title="Click here Download">
						<span class="span-first" style="font-size: 13px;font-weight: 500; color: #fff;">
								<span style="font-size: 13px;font-weight: 500; color: #fff;">
									Extension for submission of proposals under R&D Scheme for Green Hydrogen [The last date of submission of applications is 27.04.2024] – <i class="fa fa-file-pdf-o" style="color:rgba(199, 13, 13, 0.849)"
										aria-hidden="true"></i></span>
						
							</span>
					</a>&nbsp;

					<a href="{{documentURL}}/R&D-Scheme-under-the-National-Green-Hydrogen-Mission.pdf" target="_blank"
						title="Click here Download">
						<span class="span-first" style="font-size: 13px;font-weight: 500; color: #fff;">
								<span style="font-size: 13px;font-weight: 500; color: #fff;">
									Scheme Guidelines for the implementation of R&D Scheme under the National Green Hydrogen Mission – <i class="fa fa-file-pdf-o" style="color:rgba(199, 13, 13, 0.849)"
										aria-hidden="true"></i></span>
						
							</span>
					</a>&nbsp;

					<a href="{{documentURL}}/Call-for-Proposals-under-Research-and-Development-Scheme-of-National-Green-Hydrogen-Mission.pdf" target="_blank"
						title="Click here Download">
						<span class="span-first" style="font-size: 13px;font-weight: 500; color: #fff;">
								<span style="font-size: 13px;font-weight: 500; color: #fff;">
									Call for Proposals under Research and Development Scheme of National Green Hydrogen Mission [The last date of submission of applications is 12.04.2024] – <i class="fa fa-file-pdf-o" style="color:rgba(199, 13, 13, 0.849)"
										aria-hidden="true"></i></span>
						
							</span>
					</a>&nbsp;

					

					<a href="{{documentURL}}/Corrigendum_for_RERTD_Extension.pdf" target="_blank"
						title="Click here Download">
						<span class="span-first" style="font-size: 13px;font-weight: 500; color: #fff;">
							<a href="{{documentURL}}/Call_for_Proposal_for_uploading_on_website.pdf" target="_blank"
								title="Click here Download">
								<span style="font-size: 13px;font-weight: 500; color: #fff;">
									CLOSED - “Call for Proposals” under Renewable Energy Research and
									Technology Development
									(RE-RTD 2022) – <i class="fa fa-file-pdf-o" style="color:rgba(199, 13, 13, 0.849)"
										aria-hidden="true"></i></span>
							</a> &nbsp;&nbsp;&nbsp;
							<span class="span-first">We have received more than 1000 Applications for the latest round
								of RE-RTD Call for
								Proposals”</span>&nbsp;&nbsp;&nbsp;
							<span class="span-first">Check ‘Apply for Funding’ for details</span>&nbsp;&nbsp;&nbsp;
							<span class="span-first">India RE Innovation@75 - MNRE to soon launch a webpage on R&D
								Innovation
								Showcase</span>
							on Renewables

							<i class="fa fa-file-pdf-o" style="color:rgba(199, 13, 13, 0.849)"
								aria-hidden="true"></i></span>
					</a>&nbsp;

				</marquee>
			</div>
			<!-- <div class="row">
				<div class="col-xl-12 text-center"><button class="btn btn-cstm"><div class="external-events blinking" style="text-align: center; padding-top: 7px; font: bold;">
					<span class="" style="color: #f39c12; font-size: 22px; font-weigth: 700px"><i class="fa fa-hand-o-right"></i>&nbsp; </span>
					<a  routerLink="/login"  style="cursor: pointer" class="external-event bg-yellow ui-draggable ui-draggable-handle" title="Click here to Apply Proposal">Apply for EU-TTC Call for Proposal</a>

				</div></button></div>
			</div> -->
			<section style="padding: 0!important;"><a  routerLink="/login"  style="cursor: pointer" >
				<img src="assets/images/rndbanner.gif" alt="Click here to Apply Proposal" title="Click here to Apply Proposal" class="img-fluid" style="width: 100%;"></a>
			</section>
			<div class="news-main-container">
				<div class="news-inner-container">
					<h3>OVERVIEW OF THE MNRE R & D PORTAL</h3>
					<h6>The R&D Portal has been designed to:</h6>
					<p>Share information on MNRE R&D
						policies, programmes, and projects.</p>
					<p>Enable interested entities to
						submit an online application for funding under MNRE’s Renewable Energy – Research and Technology
						Development
						(RE-RTD) Programme.</p>
					<p>Provide a platform to showcase
						indigenous clean energy innovations and facilitate scale-up and adoption.</p>
					<p>Share information and resources
						on the R&D projects undertaken by the MNRE R&D Division</p>

					<!-- <p> <span> <img src="assets/images/main-home-slider/Ellipse 36.png" alt=""> </span> Overview of R&D Portal Overview of R&D Portal Overview of R&D Portal Overview of R&D Portal Overview of R&D Portal  Overview of R&D Portal  Overview of R&D Portal
										Overview of R&D Portal Overview of R&D Portal Overview of R&D Portal
									</p> -->
					<!-- <p>. Overview of R&D Portal Overview of R&D Portal Overview of R&D Portal Overview of R&D Portal Overview of R&D Portal
										Overview of R&D Portal Overview of R&D Portal Overview of R&D Portal
									</p>
									<p>. Overview of R&D Portal Overview of R&D Portal Overview of R&D Portal Overview of R&D Portal Overview of R&D Portal
										Overview of R&D Portal Overview of R&D Portal Overview of R&D Portal
									</p>
									<p>. Overview of R&D Portal Overview of R&D Portal Overview of R&D Portal Overview of R&D Portal Overview of R&D Portal
										Overview of R&D Portal Overview of R&D Portal Overview of R&D Portal
									</p> -->
				</div>
				<div class="news-inner-container">
					<div class="news_header">
						<div class="newshead">
							<a href="{{documentURL}}/Call_for_Proposal_for_uploading_on_website.pdf" target="_blank"
								title="Click here Download">
								<h4><span>R & D in News</span>
								</h4>
							</a>
						</div>
					</div>
					<div class="news_content">
						<marquee behavior="scroll" direction="up" scrollamount="6" scrolldelay="120"
							onmouseover="this.stop();" onmouseout="this.start();"
							style="height:360px !important; overflow: hidden !important;">
							<table class="table">
								<tr>
									<td>
										<!-- <h5 style="color:green; font-size:1.3em">May</h5> -->
										<!-- <h3>26</h3> -->
									</td>
									<td>
										<p>The online application process for the Innovation Challenge on Circularity in Renewable Energy Technologies will commence on [23 June 2025].<a  style="color:aqua;" target="_blank" href="{{documentURL}}/Call-for-Proposals-document-Innovation-Challenge-for-Circularity-in-Renewable-Energy-Technologies.pdf"><img height="18px" src="assets/images/click.png"></a>
											</p>
											
										<p>Final Extension for submission of proposals under R&D Scheme for Green
											Hydrogen [The last date of submission of applications is 12.05.2024] <a  style="color:aqua;" target="_blank" href="{{documentURL}}/Final_Extension_for_R&D_Call_for_Proposals.pdf"><img height="18px" src="assets/images/click.png"></a>
											[26 April 2024]</p>

										<p>Extension for submission of proposals under R&D Scheme for Green Hydrogen [The last date of submission of applications is 27.04.2024] <a  style="color:aqua;" target="_blank" href="{{documentURL}}/Extension_of_R&D_Proposals_Submission_Deadline.pdf"><img height="18px" src="assets/images/click.png"></a>
											[9 April 2024]</p>

										<p>Industry Transfer of CSIR-NAL's NALSUN-Next Generation Solar Thermal Coating <a  style="color:aqua;" href="https://twitter.com/csirnalofficial?lang=en"><img height="18px" src="assets/images/click.png"></a>
											[14 February 2024]</p>
										
											<p>Industry Transfer of CSIR-NAL's NALSUN-Next Generation Solar Thermal Coating <a  style="color:aqua;" href="https://twitter.com/csirnalofficial?lang=en"><img height="18px" src="assets/images/click.png"></a>
												  [14 February 2024]</p>
										
									
											<p>Solar Thermal Technologies In Focus At Conference Backed By MNRE, NSEFI
												<a  style="color:aqua;" href="https://www.saurenergy.com/solar-energy-news/solar-thermal-technologies-in-focus-at-conference-backed-by-mnre-nsefi"><img height="18px" src="assets/images/click.png"></a> [14 February 2024]</p>
										
									
											<p>Industry Transfer of CSIR-NAL's NALSUN-Next Generation Solar Thermal Coating
												<a  style="color:aqua;" href="https://twitter.com/csirnalofficial?lang=en%5D"><img height="18px" src="assets/images/click.png"></a> [14 February 2024]</p>
									
									
											<p>India and EU seek ways of collaboration on green hydrogen at the Workshop 
												hosted by the MNRE and the Office of Principal Scientific Adviser (PSA)
												<a  style="color:aqua;" href="https://pib.gov.in/PressReleasePage.aspx?PRID=1966863"><img height="18px" src="assets/images/click.png"></a> [11 October 2023] </p>
								
									
											<p>MNRE Workshop on Solar Thermal Technologies
												<a  style="color:aqua;" href="https://www.linkedin.com/posts/ministry-of-new-and-renewable-energy-mnre_mnreindia-solarthermal-solarwaterheater-activity-7108041001226649600-sF5k?utm_source=share&utm_medium=member_desktop"><img height="18px" src="/assets/images/click.png"></a> [13 September 2023]</p>
									
								
											<p>In a first, NTPC starts trial run of hydrogen bus in Leh 
												<a  style="color:aqua;" href="https://twitter.com/csirnalofficial?lang=en"><img height="18px" src="assets/images/click.png"></a> [18 August 2023]</p>
									
									
											<p>Launch of Mission on Advanced and High-Impact Research (MAHIR) - funded by MoP and MNRE
												<a  style="color:aqua;" href="https://pib.gov.in/PressReleaseIframePage.aspx?PRID=1930368"><img height="18px" src="/assets/images/click.png"></a> [7 June 2023] </p>
									
										
										
											<p>Secretary MNRE launched the R&D Portal at the MNRE R&D Conclave 2023
												<a  style="color:aqua;" href="https://newsmantra.in/secretary-mnre-india-shri-bhupinder-s-bhalla-launched-the-mnre-rd-portal-during-the-rd-conclave-on-renewable-energy/"><img height="18px" src="/assets/images/click.png"></a> [12 April 2023] </p>
										
										
									
											<p>Activities finalised to be considered for trading of carbon credits under
												Article 6.2
												mechanism to facilitate transfer of emerging technologies and mobilise
												international
												finance in India <a  style="color:aqua;" href="https://pib.gov.in/PressReleaseIframePage.aspx?PRID=1900216"><img height="18px" src="assets/images/click.png"></a> [17 FEB 2023]</p>
									
									
											<p> MNRE implements “Renewable Energy Research and Technology Development
												Programme” for
												promotion of indigenous technology development for wide spread
												deployment of new and
												renewable energy <a  style="color:aqua;" href="https://pib.gov.in/PressReleaseIframePage.aspx?PRID=1897775"><img height="18px" src="assets/images/click.png"></a> [09 FEB 2023]</p>
										
										
											<p>Union Minister for Road Transport and Highways, Shri Nitin Gadkari
												highlighted
												R&D projects on hydrogen and fuel cells supported under MNRE’s Renewable
												Energy
												Research and Technology Development programme (RE-RTD).<a  style="color:aqua;" href="https://pib.gov.in/PressReleasePage.aspx?PRID=1796799"><img height="18px" src="assets/images/click.png"></a>  posted on [9 Feb
												2022]</p>
										
										<!-- <a href="">
									<p>• HYDROGEN FUEL FOR VEHICLES; Posted On: 09 FEB 2022 2:43PM by PIB Delhi -
										https://pib.gov.in/PressReleasePage.aspx?PRID=1796799 </p>
								</a> -->
										<!-- <a href="#">
								<p>Promotion of Hydrogen as automotive Fuel; Posted On: 05 AUG 2021;</p>
							</a> -->
										<!-- <a href="#">
								<p>India’s first Hydrogen Fuel Cell-powered bus flagged off by IOC in
									collaboration with Tata Motors – in 2018</p>
							</a> -->
										
											<p>Invitation of Proposals for pilot demonstration of New and Innovative
												Solar
												Applications under GIZ ‘s bilateral project titled ‘Innovative Solar
												Areas
												(IN-Solar) <a  style="color:aqua;" href="https://mnre.gov.in/img/documents/uploads/file_f-1649163615900.pdf"><img height="18px" src="assets/images/click.png"></a>
											</p>
										
										<!-- <a href="">
									<p>• IISc develops new technology to produce green hydrogen from biomass [
										https://indianexpress.com/article/cities/bangalore/iisc-researchers-technology-green-hydrogen-biomass-8025223/]
										AND
										[https://iisc.ac.in/events/generating-green-hydrogen-from-biomass-an-abundant-renewable-energy-source/]
									</p>
								</a> -->
										<!-- <a href="">
									<p>• https://pib.gov.in/PressReleasePage.aspx?PRID=1742793 </p>
								</a> -->
										<!-- <a href="">
									<p>• https://energy.economictimes.indiatimes.com/news/oil-and-gas/indias-first-hydrogen-fuel-cell-powered-bus-flagged-off-by-ioc/63272303
									</p>
								</a> -->
										<!-- <p> - Format for Proposal Submission </p>
								<p> -Apply for Funding</p>
								<p> - MNRE R&D in News</p> -->
									</td>
								</tr>
								<tr>
							</table>

						</marquee>
					</div>
				</div>
			</div>
			<div class="progress-bar-outer-container">
				<h3 class="heading-bar">IMPACT DASHBOARD</h3>

				<div class="progress-bar-inner-container">
					<div class="progress-bar-box-container">
						<!-- <h6>Registered PI</h6> -->
						<span><img src="assets/images/main-home-slider/Group 127.png" alt=""> </span>
					</div>
					<div class="progress-bar-box-container">
						<div class="box-container">
							<h1>₹1.11<br><span>Billion</span></h1>
						</div>
						<div class="box-container">
							<h3> Total Funds <br> Invested <br> <span> (*Since the year 2017) </span> </h3>
						</div>
					</div>
				</div>
				<div class="progress-bar-inner-container">
					<div class="progress-bar-box-container">
						<!-- <h6>Registered Projects </h6> -->
						<span><img src="assets/images/main-home-slider/Group 128.png" alt=""> </span>
					</div>
					<div class="progress-bar-box-container">
						<div class="box-container">
							<h1>225</h1>
						</div>
						<div class="box-container">
							<h3>Total<br>Publications<br><span>(Atleast*)</span></h3>
						</div>
					</div>
				</div>
				<div class="progress-bar-inner-container">
					<div class="progress-bar-box-container">
						<!-- <h6>Ongoing Projects</h6> -->
						<span><img src="assets/images/main-home-slider/Group 130.png" alt=""> </span>
					</div>
					<div class="progress-bar-box-container">
						<div class="box-container">
							<h1>9 </h1>&nbsp;&nbsp;&nbsp;
							<h3> Patents Generated </h3>
						</div>
						<div class="box-container">
							<h1>7 </h1>&nbsp;&nbsp;&nbsp;
							<h3> Patents Filed </h3>
						</div>
					</div>
				</div>
				<div class="progress-bar-inner-container">
					<div class="progress-bar-box-container">
						<!-- <h6>Completed Projects</h6> -->
						<span><img src="assets/images/main-home-slider/Group 129.png" alt=""> </span>
					</div>
					<div class="progress-bar-box-container">
						<div class="box-container">
							<h1>10</h1>
							<h3> New Products <br> Developed </h3>
						</div>
					</div>
				</div>
				<div class="progress-bar-inner-container">
					<div class="progress-bar-box-container">
						<!-- <h6>Registered PI</h6> -->
						<span><img src="assets/images/main-home-slider/Group 208.png" alt=""> </span>
					</div>
					<div class="progress-bar-box-container">
						<!-- <div class="box-container"> -->
						<!-- <h1>₹1.11<br><span>Billion</span></h1> -->
						<!-- </div> -->
						<div class="box-container">
							<h1>{{dashboardCount[0]?.value}}<br></h1>
							<h3> Total Registered PIs</h3>
						</div>
					</div>
				</div>
				<div class="progress-bar-inner-container">
					<div class="progress-bar-box-container">
						<!-- <h6>Registered PI</h6> -->
						<span><img src="assets/images/main-home-slider/Group 207.png" alt=""> </span>
					</div>
					<div class="progress-bar-box-container">
						<div class="box-container">
							<h1>13<br></h1>
						</div>
						<div class="box-container">
							<h3> Ongoing <br> Projects <br> <span> </span> </h3>
						</div>
					</div>
				</div>
			</div>
			<!-- <div class="row row-projects-img-conainer d-flex justify-content-around ">
				<div class="col-10 d-flex justify-content-around flex-wrap">
					<div class="col-4 mb-3">
						<img src="assets\images\main-home-slider\Group 120.png" alt="" class="col-12">
					</div>
					<div class="col-4 mb-3">
						<img src="assets\images\main-home-slider\Group 121.png" alt="" class="col-12">
					</div>
				</div>
			</div> -->

			<div class="key-pillars-main-container">
				<h3>Key Pillars of Our Work</h3>
				<div class="key-pillars-outer-container">
					<div class="news-inner-container">
						<div class="news_header news-header-container">
							<div class="newshead">
								<div class="news-header-img-container">
									<img src="/assets/images/main-home-slider/Group 131.png" alt="">
								</div>
								<h6><span>1. Fund R&D projects on <br> Renewable energy technologies</span>
								</h6>
							</div>
							<div class="news-body-container">
								
								<a target="_blank" href="{{documentURL}}/MNRE_R&D_policy/MNRE_R&D_RE_RTD_Policy_2021.pdf">
								<p> Renewable Energy – Research and Technology Development (RE-RTD) Scheme
									<!-- (<a href="#">Click Here</a>)  -->
								</p></a>
								<a href="./apply-for-funding">
								<p> Apply for Funding
									<!-- (<a href="#">Click Here</a>)  -->
								</p></a>
								<a href="./key-initiatives">
								<p> Our Projects
									<!-- (<a href="#">Click Here</a> ) -->
								</p></a>
							</div>
						</div>
						<div class="news_content news-body-container">
							<!-- <marquee behavior="scroll" direction="up" scrollamount="6" scrolldelay="120" onmouseover="this.stop();"
							 onmouseout="this.start();" style="min-height:370px;">
								<table class="table">
									<tr>
										<td> -->
							<!-- <h5 style="color:green; font-size:1.3em">May</h5> -->
							<!-- <h3>26</h3> -->
							<!-- </td>
										<td>
											<a href="{{documentURL}}/documentUploads/ImportantDocs/Guidelines_1_How_to_Submit_Research_Proposal.pdf" target="_blank" title="Click here Download"> -->
							<!-- <p > - Renewable Energy – Research and Technology Development (RE-RTD) Scheme (Click here) </p>
												<p > - Apply for Funding (click here) </p>
												<p > - Our Project (click here ) </p> -->
							<!-- </a>
										</td>
									</tr>
									<tr>
								</table>
								
							</marquee> -->
						</div>
					</div>
					<div class="news-inner-container">
						<div class="news_header news-header-container">
							<div class="newshead">
								<div class="news-header-img-container">
									<img src="assets/images/main-home-slider/Group 134.png" alt="">
								</div>
								<h6><span>2. Encourage Innovation <br><span> Innovation </span> </span>
								</h6>
							</div>
							<div class="news-body-container">
								<a target="_blank" href="{{documentURL}}/pdf/MNRE-Abhinav-Soch-Nayee-Sambhawanayen.pdf">
								<p> Innovative Ideas in New and Renewable Energy-“Abhinav Soch-Nayee Sambhawanayen"
									<!-- (<ahref="#">Click Here</a>) -->
								</p></a>
								<!-- <p> - Submit your interest in RISE Innovation Showcase
						</p> -->
							</div>
						</div>
						<div class="news_content news-body-container">
							<!-- <marquee behavior="scroll" direction="up" scrollamount="6" scrolldelay="120" onmouseover="this.stop();"
							 onmouseout="this.start();" style="min-height:370px;">
								<table class="table">
									<tr>
										<td> -->
							<!-- <h5 style="color:green; font-size:1.3em">May</h5> -->
							<!-- <h3>26</h3> -->
							<!-- </td>
										<td>
											<a href="{{documentURL}}/documentUploads/ImportantDocs/Guidelines_1_How_to_Submit_Research_Proposal.pdf" target="_blank" title="Click here Download"> -->
							<!-- <p >- Innovative Ideas in New and Renewable Energy-“Abhinav Soch-Nayee Sambhawanayen"(click here)</p>
												<p >- Submit your interest in RISE Innovation Showcase (click here)</p> -->
							<!-- </a>
										</td>
									</tr>
									<tr>
								</table>
								
							</marquee> -->
						</div>
					</div>

					
					<div class="news-inner-container">
						<div class="news_header news-header-container">
							<div class="newshead">
								<div class="news-header-img-container">
									<img src="/assets/images/main-home-slider/Group 133.png" alt="">
								</div>
								<h6><span>3. Bilateral projects on <br> Innovation</span>
								</h6>
							</div>
							<div class="news-body-container">
								
								<p> Read about our ongoing I-SUN project <a target="_blank" href="{{documentURL}}/R&D_division_reports/Background_Note_MNRE-GIZ_ISUN_Project.pdf">here</a> 
									<!-- (<a href="#">Resources Webpage</a>) -->
								</p>
							</div>
						</div>
						<div class="news_content news-body-container">
							<!-- <marquee behavior="scroll" direction="up" scrollamount="6" scrolldelay="120" onmouseover="this.stop();"
							 onmouseout="this.start();" style="min-height:370px;">
								<table class="table">
									<tr>
										<td> -->
							<!-- <h5 style="color:green; font-size:1.3em">May</h5> -->
							<!-- <h3>26</h3>
										</td>
										<td>
											<a href="{{documentURL}}/documentUploads/ImportantDocs/Guidelines_1_How_to_Submit_Research_Proposal.pdf" target="_blank" title="Click here Download"> -->
							<!-- <p >- Read about our ongoing I-SUN project here (Resources webpage)</p> -->
							<!-- </a>
										</td>
									</tr>
									<tr>
								</table>
								
							</marquee> -->
						</div>
					</div>
				</div>
			</div>
			<div class="key-projects-main-container">
				<div class="key-projects-inner-container-frist">
					<h3>MNRE R&D KEY PROJECT HIGHLIGHTS</h3>
				</div>
				<div class="key-projects-outer-container">
					<div class="key-projects-inner-container">
						<div class="swiper-container slider-outer-container" [swiper]="swiperResponsive">
							<div class="swiper-wrapper slider-inner-container">
								<div class="swiper-slide slider-inner-box-container"
									*ngFor="let Item of keyRelatedProducts">
									<div class="img-container slider-img-container">
										<img src="{{Item.src}}" alt="Group-banner">
									</div>
								</div>
							</div>
							<!-- <div class="swiper-scrollbar"></div> -->
							<div class="swiper-pagination swiper-outer-container"></div>
							<!-- <div class="swiper-button-prev"></div> -->
							<!-- <div class="swiper-button-next swiper-button-next-container"></div> -->
						</div>
						<div class="swiper-button-prev swiper-button-prev-container"></div>
						<div class="swiper-button-next swiper-button-next-container"></div>
					</div>
					<div class="key-projects-inner-container"></div>
				</div>
			</div>
			<div class="our-section-outer-container">
				<div class="key-pillars-outer-container">
					<div class="news-inner-container">
						<div class="news_header news-header-container">
							<div class="newshead">
								<h6><span>Our Centres of Excellence</span>
								</h6>
							</div>
							<div class="news-body-container body-hover-contaner">
								<a href="https://nise.res.in/">
									<p>National Institute of Solar Energy (NISE), Gurugram</p>
								</a>
								<a href="https://niwe.res.in/">
									<p>National Institute of Wind Energy</p>
								</a>
								<a href="https://www.nibe.res.in/">
									<p>Sardar Swaran Singh National Institute of Bioenergy (SSS-NIBE), Kapurthala</p>
								</a>
							</div>
						</div>

					</div>
					<div class="news-inner-container">
						<div class="news_header news-header-container">
							<div class="newshead">
								<h6><span>PSUs</span>
								</h6>
							</div>
							<div class="news-body-container body-hover-contaner">
								<a href="https://www.seci.co.in/">
									<p>Solar Energy Corporation of India (SECI)
									</p>
								</a>
								<a href="https://www.ireda.in/home">
									<p>Indian Renewable Energy Development Agency (IREDA) </p>
								</a>
							</div>
						</div>

					</div>
					<div class="news-inner-container">
						<div class="news_header news-header-container">
							<div class="newshead">
								<h6><span>International Collaboration Mechanisms</span>
								</h6>
							</div>
							<div class="news-body-container body-hover-contaner">
								<a href="https://mnre.gov.in/international-relations/overview">
									<p>International MoUs on R&D </p>
								</a>
								<a href="http://mission-innovation.net/our-members/india/plans-and-priorities/">
									<p>Mission Innovation </p>
								</a>
								<a href="https://mnre.gov.in/isa/">
									<p>ISA</p>
								</a>
							</div>
						</div>

					</div>
				</div>
			</div>
		</section>
	</div>
</div>